import { render, staticRenderFns } from "./LayoutResource.vue?vue&type=template&id=73969d88&scoped=true&lang=html&"
import script from "./LayoutResource.vue?vue&type=script&lang=js&"
export * from "./LayoutResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73969d88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
